import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import 'react-phone-input-2/lib/style.css';
import Success_horozontal_Lottie from '../../../../animations/success_horozontal_Lottie/Success_horozontal_Lottie';
import Proceed_btn from '../../../../common_components/common_btn/proceed_btn/Proceed_btn';
import Successfull_horizontal_Modal from '../../../../common_components/common_modal/successfull_horizontal_Modal/Successfull_horizontal_Modal';
import "./Bank_details_tab_content.css";

function Bank_details_tab_content() {
  const [phone, setPhone] = useState('');
  const [modalShow, setModalShow] = React.useState(false);

  return (
    <>
      <section className='Personal_details_tab_content Password_tab_content'>
        <div className="profile_form_holder">
          <Form>
            <div className="row">
              

              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>Account Holder Name</Form.Label>
                  <Form.Control type="text" placeholder="Enter Account Holder Name" />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>Account Number</Form.Label>
                  <Form.Control type="text" placeholder="Enter Account Number" />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>IDFC Code</Form.Label>
                  <Form.Control type="text" placeholder="Enter IDFC Code" />
                </Form.Group>
              </div>



              <div className="col-12  mt-5">
                <div className="btn_holder">

                  <Proceed_btn btnText="Save" className={"save_changes_btn"} onClick={() => setModalShow(true)} />
                </div>

              </div>
            </div>
          </Form>
        </div>
      </section>

      <Successfull_horizontal_Modal
        show={modalShow}
        message=" Your KYC is now complete!   "
        subMessage="Deposits and withdrawals will be activated shortly. We’ll reach out to you soon."
        onHide={() => setModalShow(false)}
        lottie={<Success_horozontal_Lottie />}
      />
    </>
  );
}

export default Bank_details_tab_content;
